import { Component, ViewChild, Inject } from '@angular/core';
import { DOCUMENT } from "@angular/platform-browser";
import { Router } from '@angular/router';
import { Payee, PayeeWebChecklist, PayeeDetail } from '../../shared/sdk/models';
import { PayeeApi, PayeeDetailApi, StorageApi } from '../../shared/sdk/services';
import { FormPage } from '../../shared/app/classes/form-page'
import { GlobalEventsManager } from '../../events-manager.component';
import { SubmissionDetailService } from "../../shared/app/services/";
import { Validation } from '../../shared/app/services/validation';

@Component({
  selector: 'update-biz-acc',
  templateUrl: 'update-biz-acc.component.html',
  providers: [
    { provide: 'Window',  useValue: window },
    Validation
  ],
  styleUrls: ['../application.css']
})

export class UpdateBizAccComponent extends FormPage {

  @ViewChild('clrSubmit') clrSubmit;
  payeeDetailApi: PayeeDetailApi;
  m2upayShow:boolean = false;

  business_account_no:any;
  account_number_collection:any;
  account_number_charging:any;
  constructor(
    userApi: PayeeApi,
    payeeDetailApi: PayeeDetailApi,
    storageApi: StorageApi,
    eventsManager: GlobalEventsManager,
    protected router: Router,
    private submissionDetailService: SubmissionDetailService,
    protected validation: Validation,
    @Inject(DOCUMENT) protected document: Document
  ) { 
    super(new PayeeWebChecklist(), userApi, storageApi, eventsManager);
    this.payeeDetailApi= payeeDetailApi;
    this.eventsManager.loaded(false);
  }

  
  // Initialisation
  async ngOnInit() { 
    await this.populateFormData();
    // Reload script.js
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'js/script.js';
    script.onload = () => {
        console.log('SCRIPT LOAD');
    };           
    script.onerror = () => console.log('SCRIPT ERROR'); 
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  populateFormData() {
    this.userApi.findById(this.userApi.getCurrentId(),{include:["details","m2uPayAccountDetails"]}).subscribe(
      (payee:Payee) => {
        console.log(payee);
        if (payee.details && payee.details.business_account_no == null) {

          // console.log(payee.m2uPayAccountDetails['account_number_collection'])
          // console.log(payee.m2uPayAccountDetails['account_number_charging'])
          if (payee["m2uPayAccountDetails"]) {
            if (payee.m2uPayAccountDetails && payee.m2uPayAccountDetails['account_number_collection'] == null && payee.m2uPayAccountDetails['account_number_charging'] == null) {
              this.m2upayShow = true;
            }
          }
          
          this.eventsManager.loaded(true);
        } 
        else{

          // this.eventsManager.showPopUp("You have already filled in your Maybank Current Account No.");
          
          // this.router.navigate(['/dashboard']);
          this.eventsManager.loaded(true);
        }
        
      },
      err => {
        console.log(err);
        this.eventsManager.logout(true);
        // this.router.navigate(['/dashboard']);
        this.eventsManager.showPopUp("Your session has expired. Please login.");
        this.eventsManager.loaded(true);
      }
    );
  }

  addEventListeners() {}

  // Validation
  validate() {
    this.clrSubmit.nativeElement.click();

    this.valid = true;

    this.valid = this.business_account_no && this.valid;
    // console.log(this.valid)
    if (this.m2upayShow) {
      console.log(this.valid)
      this.valid = this.account_number_collection && this.account_number_charging && this.valid;
    }
    console.log(this.valid)
    // console.log(this.valid)
    let elements = this.document.getElementsByName('biz-acc-form')[0].getElementsByClassName('error');

    console.log({elements})
    for(var i = 0; i < elements.length; i++){
      console.log(i);
      console.log(elements[i].parentElement.parentElement.getAttribute('hidden'));
      console.log(elements[i].parentElement.getAttribute('hidden'));
      if (
        elements[i].parentElement.parentElement.getAttribute('hidden') == null && 
        elements[i].parentElement.getAttribute('hidden') == null) {
        this.valid = elements.length <= 0 && this.valid;
      }
      
    }
    console.log(this.valid)
    // this.valid = elements.length == 0 && this.valid;
console.log(this.valid)  
    return this.valid;
  }

  // Save form page
  save(submit?: boolean) {
    // Send to temp storage
    let that = this;
    return [];
  }

  submit(submit?: boolean) {
    let that = this;
    if (!this.validate() && submit) {
      that.eventsManager.showPopUp("Please fill in and ensure all the fields are valid.");
    }else{

      let details ={
        business_account_no:this.business_account_no,
        account_number_collection:this.account_number_collection,
        account_number_charging:this.account_number_charging
      }
      // Send to temp storage
      let promises =[];
      let p = new Promise (function(resolve, reject) {
        that.payeeDetailApi.updateBusinessAccount(that.userApi.getCurrentId(),details).subscribe(
          updatedPayeeDetails => {
            if (updatedPayeeDetails) {
              
              
              resolve(updatedPayeeDetails);

            }else{
              that.eventsManager.failedSavePopUp();
              
            }
              
          },
          err => {

            reject(err);
          }
        );
      });
      p.then(
        res => 
        {
          this.eventsManager.showPopUp("Maybank Current Account submitted successfully.");
          that.router.navigate(['/dashboard'])
        }
      )
      .catch(
        err => 
        {
          console.log("updateDetails err")
            console.log({err})
            
            that.eventsManager.showPopUp("Failed to submit new Maybank Current Account No.");
        }
      )
     
    }
   
  }
  // Scrolling
  scrollToTop() {
    window.scroll(0, 0);
    document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = 0;
  }

  scrollToSave() {
    //document.body.getElementsByClassName('scroll_checklist')[0].scrollTop = document.getElementById('save_checklist').offsetTop;
  }

  updateDocStatus() {}
  validateDocs() {}

  // Before submit, clean up backend data
  cleanUpData() {
    return [];
  }


}
